
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
//import {Row, Col, Container, Card} from 'react-bootstrap';
import { Row, Col, Container, Card, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import Select from 'react-select';

const Fees_Desc = () => {

  const [isEditable, setIsEditable] = useState(false);
  const [errors, setErrors] = useState({});
  //  const [dropdowns, setDropdowns] = useState({ premTypes: [], mainComp: [] });

  // Header State
  const [headerData, setHeaderData] = useState({
    hdr_fee_code: '',
    hdr_fee_desc: '',
    hdr_fee_type: '',
    hdr_refundable: '',
    hdr_incl_report: '',
    hdr_disp_ord: '',
  });

  // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      fee_code: '',
      fee_desc: '',
      fee_type: '',
      disp_fee_type: '',
      refundable: '',
      incl_report: '',
      disp_ord: '',
    }
  ]);

  useEffect(() => {

    populateData();

  }, []);

  const populateData = async () => {

    try {

      setChildRows([]);

      const response = await axios.get(`${BASE_URL}/api/get_mst_fees_desc`);

      if (response.data && response.data.length > 0) {
        setChildRows(response.data);
      }

    } catch (err) {
      console.error("Error loading Data in Common_Master", err);
    }

  }

  const handleNew = () => {

    setIsEditable(true);
    setHeaderData({
        hdr_fee_code: '',
        hdr_fee_desc: '',
        hdr_fee_type: 'M',
        hdr_refundable: 'N',
        hdr_incl_report: 'Y',
        hdr_disp_ord: '',
      });

  };

  const handleSave = async () => {

    const newErrors = {};

    if (!headerData.hdr_fee_desc || !headerData.hdr_fee_desc) {
      newErrors.hdr_fee_desc = 'Error';
      toast.error('Please enter Fees Description');
    }
    else if (!headerData.hdr_disp_ord || headerData.hdr_disp_ord === 0) {
      newErrors.hdr_disp_ord = 'Error';
      toast.error('Please enter Display Order');
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      const firstErrorKey = Object.keys(newErrors)[0];
      if (firstErrorKey) {
        const el = document.getElementsByName(firstErrorKey)[0];
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.focus(); // 🔥 bonus (cursor goes there)
        }
      }
      return;
    }

    const isConfirmed = window.confirm("Sure you want to Save the record ?");

    if (!isConfirmed) return;

    const mstFeesdata = {
      header: headerData,
    };

//console.log('formheaderData.hdr_fee_code =========> ', headerData.hdr_fee_code);
    const response = await axios.post(`${BASE_URL}/api/save_mst_fees_desc`, mstFeesdata);

    if (response.data.message === '1') {
      toast.success('Data saved successfully.')
      setIsEditable(false);
      setHeaderData({
        hdr_fee_code: '',
        hdr_fee_desc: '',
        hdr_fee_type: '',
        hdr_refundable: '',
        hdr_incl_report: '',
        hdr_disp_ord: '',
      });
      populateData();
    }

  };

  const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      setIsEditable(false);
      setHeaderData({
        hdr_fee_code: '',
        hdr_fee_desc: '',
        hdr_fee_type: '',
        hdr_refundable: '',
        hdr_incl_report: '',
        hdr_disp_ord: '',
      });
    }
  };

  const handleChange = (e) => {

    const { name, value } = e.target;

    setHeaderData(prev => ({ ...prev, [name]: value }));

    setErrors(prev => ({ ...prev, [name]: "" }));

  }

  const handleRowClick = async (fee_code, fee_desc, fee_type, refundable, incl_report, disp_ord) => {
    try {

      setHeaderData({
        hdr_fee_code: '',
        hdr_fee_desc: '',
        hdr_fee_type: '',
        hdr_refundable: '',
        hdr_incl_report: '',
        hdr_disp_ord: '',
      });

      setHeaderData({
        hdr_fee_code: fee_code,
        hdr_fee_desc: fee_desc,
        hdr_fee_type: fee_type,
        hdr_refundable: refundable,
        hdr_incl_report: incl_report,
        hdr_disp_ord: disp_ord,
      });

      setIsEditable(true);

    } catch (error) {
      console.error('Error fetching Fees Desc data:', error);
    }
  };



  return (
    <Container fluid className="p-3">
      {/* Header Card */}
      <Card className="mb-4 p-3">

        <Row className="mb-3">

          <Col md={7}>
            <InputGroup>
              <InputGroup.Text style={{ width: "150px" }}> Fees Description
              </InputGroup.Text>
              <input className={`form-control ${errors.hdr_fee_desc ? "is-invalid" : ""}`}
                type="text"
                name="hdr_fee_desc"
                value={headerData.hdr_fee_desc}
                onChange={handleChange}
                disabled={!isEditable} />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "100px" }}> Fees Type
              </InputGroup.Text>
              <select className={`form-select ${errors.hdr_fee_type ? "is-invalid" : ""}`} disabled={!isEditable}
                name="hdr_fee_type" value={headerData.hdr_fee_type} onChange={handleChange}>
                <option value="M">Monthly </option>
                <option value="Q">Quaterly </option>
                <option value="H">Half Yearly </option>
                <option value="A">Annualy </option>
                <option value="O">One Time </option>
                <option value="D">Adhoc </option>
              </select>
            </InputGroup>
          </Col>

          <Col md={2}>
            <InputGroup>
              <InputGroup.Text style={{ width: "100px" }}> Inclusive
              </InputGroup.Text>
              <select className={`form-select ${errors.hdr_incl_report ? "is-invalid" : ""}`} disabled={!isEditable}
                name="hdr_incl_report" value={headerData.hdr_incl_report} onChange={handleChange}>
                <option value="Y">Yes </option>
                <option value="N">No </option>
              </select>
            </InputGroup>
          </Col>

        </Row>

        <Row className="mb-3">

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "150px" }}> Refundable
              </InputGroup.Text>
              <select className={`form-select ${errors.hdr_refundable ? "is-invalid" : ""}`} disabled={!isEditable}
                name="hdr_refundable" value={headerData.hdr_refundable} onChange={handleChange}>
                <option value="N">No </option>
                <option value="Y">Yes </option>
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "130px" }}> Disp Order
              </InputGroup.Text>
              <input className={`form-control ${errors.hdr_disp_ord ? "is-invalid" : ""}`}
                style={{ textAlign: "right" }}
                type="number"
                name="hdr_disp_ord"
                value={headerData.hdr_disp_ord}
                onChange={handleChange}
                disabled={!isEditable} />
            </InputGroup>
          </Col>

          <Col md={6}>

            <div className="d-flex justify-content-end gap-2 flex-wrap">

              <button type="button" className="btn btn-primary" style={{ width: "135px" }}
                onClick={handleNew} disabled={isEditable} > New </button>

              <button type="button" className="btn btn-secondary" style={{ width: "135px" }}
                onClick={handleClear} > Clear </button>

              <button type="button" className="btn btn-success" style={{ width: "135px" }}
                onClick={handleSave} disabled={!isEditable} > Save </button>
            </div>

          </Col>

        </Row>

      </Card>

      {/* Child Table */}
      <Card className="p-3">
        {/* <h5>Maintenance Items</h5> */}
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table hover-table-rcpt">
            <thead>
              <tr>
                <th style={{ width: '5%', textAlign: 'center' }}>#</th>
                <th style={{ width: '48%', textAlign: 'left' }}>Fees Description</th>
                <th style={{ width: '15%', textAlign: 'left' }}>Fees Type</th>
                <th style={{ width: '10%', textAlign: 'center' }}>Include </th>
                <th style={{ width: '10%', textAlign: 'center' }}>Refund</th>
                <th style={{ width: '7%', textAlign: 'center' }}>Order </th>
              </tr>
            </thead>
            <tbody>
              {childRows.map((row, index) => (
                <tr key={index}
                  onClick={() => handleRowClick(row.fee_code, row.fee_desc, row.fee_type, row.refundable, row.incl_report, row.disp_ord)}
                  style={{ cursor: 'pointer', height: '40px' }} >
                  <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>
                  <td>{row.fee_desc}</td>
                  <td> {row.disp_fee_type} </td>
                  <td className="text-center"> {row.incl_report} </td>
                  <td className="text-center"> {row.refundable} </td>
                  <td className="text-end"> {row.disp_ord} </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default Fees_Desc;
